const handlePasswordVisible = () => {
	$('.form__controls--password').on('click', '.password-visible', function(event) {
		const $this = $(this);
		const $input = $this.siblings('input');

		if ($input.attr('type') === 'password') {
			$input.attr('type', 'text');
		} else {
			$input.attr('type', 'password');
		}

		event.preventDefault();
	});
}

handlePasswordVisible();
